export const locales = {
  HEBREW: 2,
}
